import { Accordion, Flex } from '@chakra-ui/react'
import { ContentContainer, ContentContainerColumn, GridField, GridFieldItem } from 'uikit/layout'
import { getDateTimeReadFormat } from 'shared/utils/dateFormatting'
import { useIdentificationsListFetch } from './services/useIdentificationsListFetch'

export const IdentificationsList = ({ userId }) => {
  const { data: identificationsList, isPending: isLoading } = useIdentificationsListFetch(userId)

  return (
    <ContentContainer>
      <ContentContainerColumn>
        <Accordion.Root defaultValue={['0']} multiple variant="enclosed">
          {identificationsList?.map((item, index) => (
            <Accordion.Item key={item.id} value={String(index)}>
              <Accordion.ItemTrigger cursor="pointer">
                <Flex flex="1" textAlign="left" minH="46px" alignItems="center">
                  {getDateTimeReadFormat(item.creationTime)}
                </Flex>
                <Accordion.ItemIndicator />
              </Accordion.ItemTrigger>
              <Accordion.ItemContent>
                <Accordion.ItemBody pb={4}>
                  <GridField>
                    <GridFieldItem label="Дата попытки идентификации" isLoading={isLoading} isReady>
                      {getDateTimeReadFormat(item?.failureDate)}
                    </GridFieldItem>
                    <GridFieldItem label="Статус идентификации" isLoading={isLoading} isReady>
                      {item?.state}
                    </GridFieldItem>
                    <GridFieldItem
                      label="Причина ошибки идентификации"
                      isLoading={isLoading}
                      isReady
                    >
                      {item?.description}
                    </GridFieldItem>
                    <GridFieldItem label="Liveness" isLoading={isLoading} isReady>
                      {item?.liveness}
                    </GridFieldItem>
                    <GridFieldItem
                      label="Совпадение эталонного фото из базы данных Армении и селфи пользователя"
                      isLoading={isLoading}
                      isReady
                    >
                      {item?.idBankSimilarityRate &&
                        `${(item?.idBankSimilarityRate * 100).toFixed(2)} %`}
                    </GridFieldItem>
                    <GridFieldItem
                      label="Совпадение фотографии из паспорта и селфи пользователя"
                      isLoading={isLoading}
                      isReady
                    >
                      {item?.mobileAppSimilarityRate &&
                        `${(item?.mobileAppSimilarityRate * 100).toFixed(2)} %`}
                    </GridFieldItem>
                    <GridFieldItem label="Комментарий поддержки" isLoading={isLoading} isReady>
                      {item?.identificationSupportComment}
                    </GridFieldItem>
                  </GridField>
                </Accordion.ItemBody>
              </Accordion.ItemContent>
            </Accordion.Item>
          ))}
        </Accordion.Root>
      </ContentContainerColumn>
    </ContentContainer>
  )
}
